<template>
  <div class="text-text-neutral-primary">
    <div class="mb-4">
      <strong class="flex items-center text-base"
        >{{ flight.dep }} → {{ flight.arr }}</strong
      >
      <p
        v-if="flight.airline && flight.fare_basis"
        class="text-text-neutral-primary"
      >
        {{
          t('contacts.refundExchangeRules.flightInfo', {
            airline: flight.airline,
            fareName: flight.fare_basis,
          })
        }}
      </p>
    </div>
    <MiniRules
      v-if="flight.mini_rules && flight.mini_rules.length > 0"
      :mini-rules="flight.mini_rules"
    />
    <template v-else>
      <FullRules
        v-for="(rule, index) in flight.rules"
        :key="index"
        :rule="rule"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import type { Airflow } from '@aviata/platform-types';

  import MiniRules from './MiniRules.vue';
  import FullRules from './FullRules.vue';

  defineProps<{ flight: Airflow.FareRules.Segment }>();
  const { t } = useI18n();
</script>
